import { useSelector } from "react-redux";

const useMakesCount = () => {
  const meta = useSelector((state) => state.MakesSlice?.meta);
  const totalMakesCount = meta?.totalCount ?? 0;

  return {
    totalMakesCount,
  };
};

export default useMakesCount;
